import React from "react";
import cn from "classnames";
import styles from "./Raffle.module.sass";
import Dropdown from "../../components/Dropdown";
import { useUser } from "../../context";
import raffle from "../../i11/Raffle";
import { rafflePageLimit } from ".";

const options = ["createdAt", "startDate", "endDate"];
const options1 = ["asc", "desc"];

const Settings = ({ filter, setFilter, setVisible, applyFunc }) => {
	const { locale } = useUser();

	const vals1 = {
		asc: {
			title: raffle[locale].asc,
			order_direction: 1,
		},
		desc: {
			title: raffle[locale].q_desc,
			order_direction: -1,
		},
	};

	const sortBy = {
		createdAt: {
			title: raffle[locale].created_at,
			order_by: "createdAt",
		},
		startDate: {
			title: raffle[locale].start_date,
			order_by: "startDate",
		},
		endDate: {
			title: raffle[locale].end_date,
			order_by: "endDate",
		},
	};

	const apply = (reset) => {
		const res = reset
			? {
					page: 1,
					limit: rafflePageLimit,
					order_direction: -1,
					order_by: "createdAt",
			  }
			: { ...filter };
		applyFunc(res);
		reset && setFilter(res);
		setVisible(false);
	};

	const handler = (name, val) => {
		setFilter((obj) => {
			return {
				...obj,
				[name]: val,
			};
		});
	};

	return (
		<div className={styles.settings}>
			<div className={styles.group}>
				<div className={styles.item}>
					<div className={styles.flex}>
						<Dropdown
							className={styles.dropdown}
							classDropdownLabel={styles.label}
							value={filter.order_by}
							setValue={(val) => handler("order_by", val)}
							options={options}
							dictionary={sortBy}
							label={raffle[locale].sort_by}
						/>
						<Dropdown
							className={styles.dropdown}
							classDropdownLabel={styles.label}
							value={options1[filter.order_direction === 1 ? 0 : 1]}
							setValue={(val) =>
								handler("order_direction", vals1[val].order_direction)
							}
							options={options1}
							dictionary={vals1}
							label={raffle[locale].order_by}
						/>
					</div>
				</div>

				<div className={styles.btns}>
					<button
						className={cn("button-stroke", styles.button)}
						onClick={() => apply("reset")}
					>
						{raffle[locale].reset}
					</button>
					<button
						className={cn("button", styles.button)}
						onClick={() => apply()}
					>
						{raffle[locale].apply}
					</button>
				</div>
			</div>
		</div>
	);
};

export default Settings;
